import { isAxiosError } from 'axios';
import { authApiV2 } from '@/api/endpoints/auth';

/**
 * After a gateway cut (502/503) or network error on `/register/complete`, ask
 * check-email whether the invite was already activated (DEF-229).
 *
 * Kept outside `RegisterPage` so Vite Fast Refresh can hot-reload the page.
 *
 * @returns true when the account is no longer registerable (treat as success).
 */
export async function recoverRegisterCompleteAfterGatewayError(
  error: unknown,
  email: string,
  checkEmail: (data: { email: string }) => Promise<
    { canRegister: true; email: string } | { canRegister: false; message: string }
  > = (data) => authApiV2.checkEmail(data),
): Promise<boolean> {
  if (!isAxiosError(error)) return false;
  const status = error.response?.status;
  const isGatewayOrNetwork =
    error.response == null || status === 502 || status === 503;
  if (!isGatewayOrNetwork) return false;
  try {
    const gate = await checkEmail({ email });
    return gate.canRegister === false;
  } catch {
    return false;
  }
}
